import $ from 'jquery'
import Backbone from 'backbone'
import * as Canvas from 'canvas'
import DisplayView from './display'
import deviceType from 'scoreboard/components/device-type'
import layoutManager from 'scoreboard/components/layout-manager'
import briefingsLayoutManager from 'scoreboard/briefings/briefings-layout-manager'
import ViewOnlyCanvasContainerView from './view-only-canvas-container-view'

var View = DisplayView.extend({
	className: DisplayView.prototype.className + ' view',
	subsection: 'overview',

	initialize: function (options) {
		DisplayView.prototype.initialize.apply(this, arguments)
		this.options = options || {}
		this.embeddedToken = this.options.embeddedToken
	},

	render: function() {
		DisplayView.prototype.render.apply(this, arguments)

		this.secure()

		this.listenTo(this.header, 'change:period', this._changePeriod.bind(this))

		this.listenTo(Backbone, 'reset:display', function () {
			// #13534 there's some logic in main.js that doesn't do a full display resize in certain briefing scenarios.
			// However, we still need to resize the canvas
			if (briefingsLayoutManager.isBriefingPresentationMode()) {
				this.canvas.resize()
			}
		}.bind(this))

		// While the drawer is up, there's no resizing of the canvas that goes on,
		// so the canvas can be clicked or resized without any resizing going on.
		// When the drawer is closed, however, go ahead and call resize on the canvas
		// so that it fits with the potentially new dimensions of the viewport/display-pane.
		this.datasetFiltersLayout.on('toggleDrawer:collapse', () => {
			this.canvas.resize()
		})

		// #43586 Chrome 96 introduced a weird bug where the text in SVGs isn't
		// sized properly when it's first rendered. If we wait until the canvas
		// is ready for display (and thus has done it's scale transform),
		// it works properly. The easiest way to do that for all widget types is
		// to just make them think fresh data has come in and force them to re-render.
		//
		// This appears to be fixed by version 97, so limiting it to previous versions.
		// Edge uses Chromium under the hood, so we'll assume it'll be fixed
		// at the same time
		//
		// #47761 However, this hack causes problems for timeline exports. As of
		// Impact 2021-sp, the export server was using Chromium 69, which wasn't
		// causing the text size bug, so don't do this hack on exports.
		if (deviceType.textSizeBug && !layoutManager.export) {
			this.listenTo(this.canvas, 'ready', () => {
				this.model.data.trigger('change')
			})
		}

		return this
	},

	secure: function() {
		this.header && this.header.conditionallyHideEditTab(this.model.isEditable())
	},

	_changePeriod: function (periodId) {
		// get new data so the dashboard widgets can update themselves
		this.model.data.fetch({periodId: periodId})
	},

	createCanvasContainer (el) {
		return new ViewOnlyCanvasContainerView({
			el,
			model: this.model,
			wobs: this.wobs,
			maestro: this.maestro,
			embeddedToken: this.embeddedToken,
			canvasConstructor: DrawerCanvas,
			minHeight: DisplayView.CANVAS_MIN_HEIGHT,
			minWidth: DisplayView.CANVAS_MIN_WIDTH
		})
	}
})

const DrawerCanvas = Canvas.FullscreenCanvas.extend({
	resize: function() {
		// If the drawer is expanded (shown on datasets filter dashboards), don't
		// do any resizing to the canvas.
		if ($('.display-layout').hasClass('is-drawer-expanded')) {
			return
		}
		Canvas.FullscreenCanvas.prototype.resize.apply(this, arguments)
	}
})

export default View

View.__filename__ = 'dashboards/display/dashboards-overview.js'
